const modules = {
  rh: { label: "RH", target: process.env.REACT_APP_EVIVESOMA_RH },
  compta: { label: "Compta", target: process.env.REACT_APP_EVIVESOMA_COMPTA },
  stat: { label: "Stat", target: process.env.REACT_APP_EVIVESOMA_STAT },
  biblio: { label: "Biblio", target: process.env.REACT_APP_EVIVESOMA_BIBLIO }
};

const ACTIVE_MODULE_KEY = "activeModule";
const trimSlashes = (value = "") => value.replace(/^\/+|\/+$/g, "");

const getTargetPath = (target) => {
  if (!target) return "";
  try {
    return trimSlashes(new URL(target, window.location.origin).pathname);
  } catch {
    return trimSlashes(target);
  }
};

const getModuleFromLegacyPath = () => {
  const currentPath = trimSlashes(window.location.pathname);

  return Object.entries(modules).find(([key, config]) => {
    const targetPath = getTargetPath(config.target);
    const legacyPath = targetPath || key;
    return currentPath === legacyPath || currentPath.startsWith(`${legacyPath}/`);
  });
};

export const setActiveModule = (moduleName) => {
  if (!modules[moduleName]) return;
  window.sessionStorage.setItem(ACTIVE_MODULE_KEY, moduleName);
};

export const getActiveModule = () => {
  const configuredModule = process.env.REACT_APP_MODULE?.toLowerCase();
  if (modules[configuredModule]) return configuredModule;

  const hostMatch = Object.entries(modules).find(([, config]) => {
    if (!config.target || !/^https?:\/\//i.test(config.target)) return false;
    return new URL(config.target).host === window.location.host;
  });
  if (hostMatch) return hostMatch[0];

  const pathMatch = getModuleFromLegacyPath();
  if (pathMatch) return pathMatch[0];

  const savedModule = window.sessionStorage.getItem(ACTIVE_MODULE_KEY);
  return modules[savedModule] ? savedModule : "rh";
};

export const getModuleConfig = (moduleName = getActiveModule()) => ({
  ...modules[moduleName],
  key: moduleName
});

export const removeLegacyModuleFromUrl = () => {
  const pathMatch = getModuleFromLegacyPath();
  if (!pathMatch) return;

  const [, config] = pathMatch;
  const legacyPath = getTargetPath(config.target) || pathMatch[0];
  const currentPath = trimSlashes(window.location.pathname);
  const cleanPath = currentPath.slice(legacyPath.length).replace(/^\/+/, "");
  const nextUrl = `/${cleanPath}${window.location.search}${window.location.hash}`;
  window.history.replaceState(null, "", nextUrl);
};

export const getModuleUrl = (moduleName, suffix = "") => {
  const target = modules[moduleName]?.target;
  const cleanSuffix = suffix ? `/${trimSlashes(suffix)}` : "";
  if (/^https?:\/\//i.test(target || "")) {
    return `${target.replace(/\/+$/, "")}${cleanSuffix}`;
  }
  return cleanSuffix || "/";
};

export default modules;
